// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"imageCard_wrapper__HFRcu","image":"imageCard_image__apXM7","link":"imageCard_link__VO7dj","content":"imageCard_content__bCIhh"};